import styled from "styled-components";
import {space} from "style/spacing";

export const IconWrapper = styled.span`
  display: block;
  width: 20px;
  ${space}
`;
